import { differenceInDays } from "date-fns";
export const contractFulfillmentErrors = ({ contract, terms, numOrders, endingInvoice, }) => {
    const unfulfilledTerms = [];
    /**
     * `createdAt` represents the original creation date of the subscription
     * exposed by getSubscriptionContractDetails.
     *
     * The binding period starts at the first of these that exists:
     * 1. `bindingPeriodStartedAt`, set explicitly on the contract, e.g. when a
     *    holdback starts a new binding period.
     * 2. `previousContractCreatedAt`, the legacy field. This is especially
     *    important for migrated SALTO contracts where it may be newer than
     *    saltoCreatedAt.
     * 3. `createdAt`.
     */
    const bindingPeriodStart = new Date(contract.bindingPeriodStartedAt ||
        contract.previousContractCreatedAt ||
        contract.createdAt);
    const daysSinceBindingPeriodStarted = differenceInDays(new Date(), bindingPeriodStart);
    if (terms.binding_period_days > daysSinceBindingPeriodStarted) {
        unfulfilledTerms.push({
            terms,
            termsMet: {
                binding_period_days: daysSinceBindingPeriodStarted,
                minimum_orders: numOrders,
            },
            type: "binding_period",
            cancellable: false,
            message: `Contract ${contract.id} is not cancellable, binding period not met. Binding period: ${terms.binding_period_days} days. Days since binding period started: ${daysSinceBindingPeriodStarted}`,
            displayMessage: `Bindingstid på ${terms.binding_period_days - daysSinceBindingPeriodStarted} dager gjenstår`,
            endingInvoice: endingInvoice
                ? {
                    sku: endingInvoice.sku,
                    name: endingInvoice.name,
                    image: endingInvoice.image,
                    price: endingInvoice.price,
                    alternativePrice: endingInvoice.alternativePrice,
                }
                : undefined,
        });
    }
    if (terms.minimum_orders > numOrders) {
        unfulfilledTerms.push({
            terms,
            termsMet: {
                binding_period_days: daysSinceBindingPeriodStarted,
                minimum_orders: numOrders,
            },
            type: "minimum_orders",
            cancellable: false,
            message: `Contract ${contract.id} is not cancellable, minimum orders not met.`,
            displayMessage: `Krav om minstekjøp ikke oppnådd.`,
        });
    }
    return unfulfilledTerms;
};
